import React, { useCallback, useEffect, useState } from 'react';
import { LanguageProvider } from './lib/i18n';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { VehicleGrid } from './components/VehicleGrid';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { VehicleDetailPage } from './components/VehicleDetailPage';
type Page = 'home' | 'vehicle-detail';
function AppContent() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const [vehicleSlug, setVehicleSlug] = useState<string>('');
  const getPageFromHash = useCallback((): {
    page: Page;
    slug: string;
  } => {
    const hash = window.location.hash;
    if (hash.startsWith('#/vehicle/')) {
      const slug = hash.replace('#/vehicle/', '');
      return {
        page: 'vehicle-detail',
        slug
      };
    }
    return {
      page: 'home',
      slug: ''
    };
  }, []);
  useEffect(() => {
    const {
      page,
      slug
    } = getPageFromHash();
    setCurrentPage(page);
    setVehicleSlug(slug);
    const handleHashChange = () => {
      const {
        page,
        slug
      } = getPageFromHash();
      setCurrentPage(page);
      setVehicleSlug(slug);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, [getPageFromHash]);
  const navigateToVehicle = (slug: string) => {
    window.location.hash = `#/vehicle/${slug}`;
  };
  const navigateToHome = () => {
    window.location.hash = '#/';
  };
  return <div className="min-h-screen bg-[#0a0a0a]" data-id="element-0">
      <Navbar onNavigateHome={navigateToHome} data-id="element-1" />
      {currentPage === 'home' ? <main data-id="element-2">
          <HeroSection data-id="element-3" />
          <VehicleGrid onVehicleClick={navigateToVehicle} data-id="element-4" />
          <AboutSection data-id="element-5" />
          <ServicesSection data-id="element-6" />
          <ContactSection data-id="element-7" />
        </main> : <main data-id="element-8">
          <VehicleDetailPage vehicleSlug={vehicleSlug} onNavigateHome={navigateToHome} data-id="element-9" />
          <ContactSection data-id="element-10" />
        </main>}
      <Footer onNavigateHome={navigateToHome} data-id="element-11" />
    </div>;
}
export function App() {
  return <LanguageProvider data-id="element-12">
      <AppContent data-id="element-13" />
    </LanguageProvider>;
}